
import RecursiveTaxonomyButtons from '@/components/RecursiveTaxonomyButtons.vue';
import { defineComponent } from "vue";

export default defineComponent({
	name: 'TaxonomyButtons',
	props: {
		availableTaxonomyTerms: {
			required: true,
			type: Object
		},
		exclude: {
			required: false,
			type: Array,
			default: () => {
				return []
			}
		},
		multiSelect: {
			required: false,
			type: Boolean,
			default: true
		},
		showTerms: {
			required: false,
			type: Object,
			default: null
		},
	},
	components: {
		RecursiveTaxonomyButtons
	},
	emits: ['updateTaxonomy'],
	expose: ['reset'],
	methods: {
		componentId(append: string) {
			return 'vueEventsPlugin' + append
		},
		updateTaxonomy(taxonomy: string, termId: number) {
			this.$emit('updateTaxonomy', taxonomy, termId, this.multiSelect)
		},
		reset() {
			if (this.$refs.recursiveTaxonomyButtons) {
				(this.$refs.recursiveTaxonomyButtons as Array<object>).forEach((group: object) => {
					(group as InstanceType<typeof RecursiveTaxonomyButtons>).reset();
				});
			}
		}
	}
})
